import { Col, Row, Button } from 'antd';
import type { RangePickerProps } from 'antd/es/date-picker';
import { cpapInstructions } from 'containers/App/selectors';
import { FormikProvider, useFormik } from 'formik';
import { Form, Input, SubmitButton, Checkbox, DatePicker } from 'formik-antd';
import React from 'react';
import { useSelector } from 'react-redux';
import Wrap from './styles';

const { RangePicker } = DatePicker;

type Props = {
  onSearch: (values?: CPAPFilterType) => void;
};

export type CPAPFilterType = {
  facility_name_for_search: string;
  patient_name: string;
  patient_id: string;
  phone_number: string;
  cpap_setting_for_search: string;
  machine_no: string;
  installation_date: RangePickerProps['value'];
  cpap_remark: string;
  other: string;
  suspension_flg: boolean;
  health_authorities: string;
  health_authorities_iids: string[];
};

const SearchCpapPage: React.FC<Props> = ({ onSearch }) => {
  const { searchValue, loading } = useSelector(cpapInstructions);

  const formik = useFormik<CPAPFilterType>({
    initialValues: searchValue,
    enableReinitialize: true,
    onSubmit: (values) => {
      onSearch(values);
    },
  });

  const handleReset = () => {
    onSearch(undefined);
    formik.resetForm();
  };

  return (
    <Wrap>
      <FormikProvider value={formik}>
        <Form>
          <Row className="detail" align="top">
            <Col span={6} className="column">
              <Form.Item
                name="facility_name_for_search"
                colon={false}
                labelCol={{ span: 9 }}
                labelAlign="left"
                label={<span className="label-search">医療機関名</span>}
              >
                <Input className="input" name="facility_name_for_search" />
              </Form.Item>
              <Form.Item
                name="cpap_setting_for_search"
                colon={false}
                labelCol={{ span: 9 }}
                labelAlign="left"
                label={<span className="label-search">機種</span>}
              >
                <Input className="input" name="cpap_setting_for_search" />
              </Form.Item>
              <Form.Item
                name="cpap_remark"
                colon={false}
                labelCol={{ span: 9 }}
                labelAlign="left"
                label={<span className="label-search">備考</span>}
              >
                <Input className="input" name="cpap_remark" />
              </Form.Item>
            </Col>
            <Col span={6} className="column">
              <Form.Item
                name="patient_name"
                colon={false}
                labelCol={{ span: 9 }}
                labelAlign="left"
                label={<span className="label-search">患者名</span>}
              >
                <Input className="input" name="patient_name" />
              </Form.Item>
              <Form.Item
                name="machine_no"
                colon={false}
                labelCol={{ span: 9 }}
                labelAlign="left"
                label={<span className="label-search">機番</span>}
              >
                <Input className="input" name="machine_no" />
              </Form.Item>
              <Form.Item
                name="other"
                colon={false}
                labelCol={{ span: 9 }}
                labelAlign="left"
                label={<span className="label-search">その他</span>}
              >
                <Input className="input" name="other" />
              </Form.Item>
            </Col>
            <Col span={7} className="column">
              <Form.Item
                name="patient_id"
                colon={false}
                labelCol={{ span: 4 }}
                labelAlign="left"
                label={<span className="label-search">患者ID</span>}
              >
                <Input className="input" name="patient_id" />
              </Form.Item>
              <Form.Item
                name="installation_date"
                colon={false}
                labelCol={{ span: 4 }}
                labelAlign="left"
                label={<span className="label-search">設置日</span>}
              >
                <RangePicker className="input" name="installation_date" format="YYYY年MM月DD日" />
              </Form.Item>
              <Form.Item name="suspension_flg" colon={false}>
                <Checkbox className="input" name="suspension_flg">
                  <span className="label-search">利用中のみ</span>
                </Checkbox>
              </Form.Item>
            </Col>
            <Col span={5} className="column">
              <Form.Item
                name="phone_number"
                colon={false}
                labelCol={{ span: 9 }}
                labelAlign="left"
                label={<span className="label-search">電話番号</span>}
              >
                <Input className="input" name="phone_number" />
              </Form.Item>
              <Form.Item
                name="health_authorities"
                colon={false}
                labelCol={{ span: 9 }}
                labelAlign="left"
                label={<span className="label-search">営業担当</span>}
              >
                <Input className="input" name="health_authorities" />
              </Form.Item>
              <div className="btn">
                <Button onClick={handleReset} className="Standard backSetup">
                  リセット
                </Button>
                <SubmitButton className="btnSearch Standard btnDefault" loading={loading} disabled={loading}>
                  絞り込み表示
                </SubmitButton>
              </div>
            </Col>
          </Row>
        </Form>
      </FormikProvider>
    </Wrap>
  );
};

export default SearchCpapPage;
